import { Outlet } from "react-router-dom";

function InventoryMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default InventoryMain;